@if (attachments.length > 0) {
<ul class="list-group">
  @for (attachment of attachments; track attachment; let i = $index) {
  @if (isStoredFile(attachment)) {
  <li [attr.data-index]="i" class="list-group-item list-group-item-action d-flex align-items-center pe-2 d-grid gap-2"
    [title]="getFilename(attachment)" (click)="openAttachment(attachment)" style="cursor: pointer;">
    <i [ngClass]="getIcon(attachment)" style="width: 20px;"></i>
    <span class="text-nowrap text-truncate">{{ getFilename(attachment) }}</span>
  </li>
  } @else {
  <li [attr.data-index]="i" class="list-group-item list-group-item-action d-flex align-items-center pe-2 d-grid gap-2"
    style="cursor: pointer;">
    <shared-view-remote-attachment [attachment]="attachment" class="w-100">
    </shared-view-remote-attachment>
  </li>
  }
  }
</ul>
}